import { render, staticRenderFns } from "./BaseFormValidation.vue?vue&type=template&id=37e0ae84&"
import script from "./BaseFormValidation.vue?vue&type=script&lang=js&"
export * from "./BaseFormValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e0ae84')) {
      api.createRecord('37e0ae84', component.options)
    } else {
      api.reload('37e0ae84', component.options)
    }
    module.hot.accept("./BaseFormValidation.vue?vue&type=template&id=37e0ae84&", function () {
      api.rerender('37e0ae84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseFormValidation.vue"
export default component.exports